import { useParams } from "react-router";
import {
  useVbsWorkOrderShowQuery,
  useVbsWorkOrderUpdateRepresentativeMutation,
  useVbsWorkOrderUpdateServiceAddressMutation,
  useVbsWorkOrderUpdateServiceContactMutation,
} from "@/services/backend/vbs/work-orders/api/work-order-api";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { ContactCardWithMutation } from "@/services/backend/contacts/components/contact-card";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";
import { WorkOrder } from "@/services/backend/vbs/work-orders/types/work-order";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { WorkOrderInternalCommentInput } from "@/services/backend/vbs/work-orders/components/work-order-comment-input";
import { WorkOrderTeamLeaderInput } from "@/services/backend/vbs/work-orders/components/work-order-team-leader-input";
import { WorkOrderExecutingBranchSelect } from "@/services/backend/vbs/work-orders/components/work-order-executing-branch-select";
import { WorkOrderBeginDateInput } from "@/services/backend/vbs/work-orders/components/work-order-begin-date-input";
import { ConnectDocumentDataCard } from "@/services/backend/connect/components/connect-document-data-card";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { WorkOrderCustomerReferenceInput } from "@/services/backend/vbs/work-orders/components/work-order-customer-reference-input";

export function WorkOrderPlanningBaseDataRoute() {
  const { workOrderId } = useParams();
  const { data: workOrder } = useVbsWorkOrderShowQuery({ id: workOrderId! });

  return (
    <div className="grid gap-2">
      <PlanningBaseData workOrder={workOrder!} />
      <ConnectDocumentDataCard
        serviceKind={GSMServiceKind.VBS}
        documentKind={GSMDocumentKind.WorkOrder}
        documentId={workOrderId!}
      />
      <ServiceAddressCardWithMutation
        id={workOrder!.id}
        address={workOrder!.serviceAddress}
        mutation={useVbsWorkOrderUpdateServiceAddressMutation}
      />
      <div className="md:grid md:grid-cols-2 md:gap-2">
        <ContactCardWithMutation
          id={workOrder!.id}
          contact={workOrder!.serviceContact}
          mutation={useVbsWorkOrderUpdateServiceContactMutation}
        />
        <RepresentativeCardWithMutation
          id={workOrder!.id}
          representative={workOrder!.representative}
          mutation={useVbsWorkOrderUpdateRepresentativeMutation}
        />
      </div>
    </div>
  );
}

export function PlanningBaseData({ workOrder }: { workOrder: WorkOrder }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Arbeitsschein")}</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4">
        <div className="grid gap-4 lg:grid-cols-2">
          <WorkOrderBeginDateInput workOrder={workOrder} />
          <WorkOrderExecutingBranchSelect workOrder={workOrder} />
          <WorkOrderTeamLeaderInput workOrder={workOrder} />
          <WorkOrderCustomerReferenceInput workOrder={workOrder} />
        </div>
        <WorkOrderInternalCommentInput workOrder={workOrder} />
      </CardContent>
    </Card>
  );
}
